<template>
  <div>
    <div v-if="!isSiteAdmin && !isSubscriber && !isClient">
      <b-container class="py-3">
        <b-row>
          <b-col md="9">
            <b-jumbotron header="Justice Story" lead="Hear Each Client. A Mitigation Report for Every Case." class="text-center">
              <p>Every client deserves to be heard. Justice Story helps defense attorneys add consistency and depth to their mitigation advocacy.</p>
              <p>Use our tool to send in-depth biographical surveys to each of your clients with an email or text message. With your client's responses, Justice Story creates an editable Mitigation Report. Attorneys can select up to 13 different validated health, AODA, and trauma screens to include along with the biographical survey.</p>
              <p>Justice Story Mitigation Reports resemble comprehensive Presentence Investigation Reports. These reports help lay the groundwork for effective and thorough plea negotiation, sentence arguments, and client understanding.</p>
              <b-button variant="primary" to="https://www.justicestory.com">Learn More</b-button>
            </b-jumbotron>
          </b-col>
          <b-col>
            <div class="text-center mt-4">
              <p>Ready to try it out?</p>
              <b-button variant="primary" to="/subscribe">Sign Up Now</b-button>
            </div>
            <hr />
            <div class="text-center mt-4">
              <p>Already a user?</p>
              <b-button variant="primary" to="/login">Log In</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-if="isSiteAdmin">
      <admin-dashboard></admin-dashboard>
    </div>
    <div v-if="isSubscriber">
      <subscriber-dashboard></subscriber-dashboard>
    </div>
    <div v-if="isClient">
      <b-container class="py-3">
        <b-row>
          <b-col>
            <p>To continue, please follow the link that was emailed or texted to you by your attorney.</p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import AuthMixin from '../Mixins/AuthMixin.vue';
import axios from "axios";

export default {
  name: "Home",
  mixins: [AuthMixin],
  props: {},
  data() {
    return {
      forms: []
    }
  },
  computed: {
    isSiteAdmin: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Site Admin');
    },
    isSubscriber: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Subscriber');
    },
    isClient: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Client');
    }
  },
  methods: {
  },
  watch: {
  },
  created() {
  },
  async mounted () {
  }
};
</script>